'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import { CommonError, handleRechallenge } from '@/service/auth'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  const r = useRouter()

  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Global Error:', error)

    // Handle 401 errors with rechallenge
    if (error instanceof CommonError && error.info.code === 401) {
      handleRechallenge()
        .then(() => {
          r.replace('/landing')
        })
        .catch((e) => {
          // Just log the error if rechallenge fails
          console.log('Rechallenge failed:', e)
        })
    }
  }, [error])

  return (
    <html>
      <body>
        <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
          <div className="max-w-lg w-full space-y-8 text-center">
            <div>
              <h2 className="mt-6 text-3xl font-extrabold text-white">
                Something went wrong!
              </h2>
              <p className="mt-2 text-sm text-gray-400">
                {error.message || 'An unexpected error occurred'}
              </p>
              {error.digest && (
                <p className="mt-1 text-xs text-gray-500">
                  Error ID: {error.digest}
                </p>
              )}
            </div>
            <div>
              <button
                onClick={() => reset()}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Try again
              </button>
            </div>
            <div className="text-sm text-gray-400">
              <p>
                If the problem persists, please contact our support team.
              </p>
            </div>
          </div>
        </div>
      </body>
    </html>
  )
}